module.exports = __webpack_public_path__ + "img/01_no.e1c2e9de.svg";